$(function () {
	new Inputmask({mask:'+7 (999) 999-99-99',placeholder: '_'})
		.mask(document.querySelectorAll('.js-phone'));


	$('.js-phone').on('focus', function(){
		$(this).trigger('click');
	})

});